module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/RQR3a4/tc-custom/9781595587664.jpg?1704272855633",
      "alt": "This image is the cover for the book Working"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Working\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("A Pulitzer Prize winner interviews workers, from policemen to piano tuners: “Magnificent . . . To read it is to hear America talking.” —"), _c('i', [_vm._v("The Boston Globe")])]), _c('br'), _vm._v(" "), _c('br'), _c('i', [_vm._v("A National Book Award Finalist and ")]), _vm._v("New York Times"), _c('i', [_vm._v(" bestseller")]), _c('br'), _vm._v(" "), _c('br'), _vm._v(" Studs Terkel’s classic oral history "), _c('i', [_vm._v("Working")]), _vm._v(" is a compelling look at jobs and the people who do them. Consisting of over one hundred interviews with everyone from a gravedigger to a studio head, this book provides a “brilliant” and enduring portrait of people’s feelings about their working lives. This edition includes a new foreword by "), _c('i', [_vm._v("New York Times")]), _vm._v(" journalist Adam Cohen ("), _c('i', [_vm._v("Forbes")]), _vm._v(")."), _c('br'), _vm._v(" "), _c('br'), _vm._v(" “Splendid . . . Important . . . Rich and fascinating . . . The people we meet are not digits in a poll but real people with real names who share their anecdotes, adventures, and aspirations with us.” —"), _c('i', [_vm._v("Business Week")]), _c('br'), _vm._v(" "), _c('br'), _vm._v(" “The talk in "), _c('i', [_vm._v("Working")]), _vm._v(" is good talk—earthy, passionate, honest, sometimes tender, sometimes crisp, juicy as reality, seasoned with experience.” —"), _c('i', [_vm._v("The Washington Post")])])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Studs Terkel\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    New Press, The\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0